import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Tooltip from "material-ui/Tooltip";

const styles = () => ({
  arrow: {
    position: "absolute",
    fontSize: 6,
    top: 0,
    left: "calc(50% - 1.5em)",
    marginTop: "-0.95em",
    width: "3em",
    height: "1em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "0 1em 1em 1em",
      borderColor: `transparent transparent #181819 transparent`,
    },
  },
  tooltipRoot: {
    display: "flex",
  },
  tooltip: {
    fontWeight: 200,
    fontSize: 13,
    backgroundColor: "#181819",
    padding: "6px 6px",
    opacity: 1,
    whiteSpace: "break-spaces",
  },
  label: {
    fontSize: "8px",
    padding: "2px 5px",
    marginRight: "4px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
    height: "10px",
    display: "flex",
    alignItems: "center",
  },
});

const Label = ({ classes, labelText, toolTipText, labelColor, labelBgColor, fontWeight }) => {
  if (!toolTipText) {
    return (
      <span className={classes.label} style={{color: labelColor, background: labelBgColor}}>{labelText}</span>
    );
  }

  return (
    <Tooltip
      placement="bottom"
      title={
        <React.Fragment>
          {toolTipText}
          <span className={classes.arrow} />
        </React.Fragment>
      }
      classes={{
        root: classes.tooltipRoot,
        tooltip: classes.tooltip,
      }}
    >
      <span className={classes.label} style={{color: labelColor, background: labelBgColor, fontWeight: fontWeight}}>{labelText}</span>
    </Tooltip>
  );
};

Label.propTypes = {
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.string.isRequired,
  toolTipText: PropTypes.string,
  labelColor: PropTypes.string,
  labelBgColor: PropTypes.string,
  fontWeight: PropTypes.string,
};

Label.defaultProps = {
  labelColor: "#FFFFFF",
  labelBgColor: "#181819",
  fontWeight: "bold",
};

export default withStyles(styles)(Label);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/parts/Label.jsx